import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts";
import "../../styles/revenueChart.css";

const RevenueChart = ({ bookings = [] }) => {
  const last6Months = [];
  const now = new Date();

  for (let i = 5; i >= 0; i--) {
    const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const monthName = date.toLocaleString("default", { month: "short" });

    const revenue = bookings
      .filter(b => {
        const bookingDate = new Date(b.created_date);
        return (
          bookingDate.getMonth() === date.getMonth() &&
          bookingDate.getFullYear() === date.getFullYear()
        );
      })
      .reduce((sum, b) => sum + (b.total_amount || 0), 0);

    last6Months.push({
      month: monthName,
      revenue
    });
  }

  return (
    <div className="revenue-card">
      <div className="revenue-card-header">
        <h3>Revenue Trend</h3>
      </div>

      <div className="revenue-card-body">
        <ResponsiveContainer width="100%" height={250}>
          <BarChart data={last6Months}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip
              formatter={(value) => `₹${value.toLocaleString()}`}
            />
            <Bar
              dataKey="revenue"
              fill="#4f46e5"
              radius={[8, 8, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default RevenueChart;
